var _defs, _g, _image, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIpLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-15 -15 130.6 128.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill: #57825f;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.3,
    cy: 49.7,
    r: 45.5,
    transform: "translate(-14.9 77.2) rotate(-67.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.8,
    y: 23.3,
    width: 33.3,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55,67.2c0,.3-.1.5-.3.7-.2.2-.5.3-.7.3h-7.2c-.3,0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7v-2c0-.3.1-.5.3-.7.2-.2.5-.3.7-.3h7.2c.3,0,.5.1.7.3.2.2.3.4.3.7v2ZM36.9,43.2c0-3.5,1.4-6.8,3.9-9.2,2.5-2.4,5.9-3.8,9.5-3.8,17.8.7,17.8,25.3,0,26-3.6,0-7-1.4-9.5-3.8-2.5-2.4-3.9-5.8-3.9-9.2h0ZM63.8,65.2h-6.7c0-.8-.3-1.6-.9-2.1-.6-.6-1.4-.9-2.2-.9h-2.6v-4c3.9-.3,7.6-1.9,10.3-4.7,2.7-2.8,4.2-6.4,4.2-10.3-.9-19.9-30.2-19.9-31,0,0,3.8,1.5,7.5,4.2,10.3,2.7,2.8,6.4,4.5,10.3,4.7v4h-2.6c-.8,0-1.6.3-2.2.9-.6.6-.9,1.3-.9,2.1h-6.7c-.4,0-.7.2-.9.5-.2.3-.2.7,0,1,.2.3.5.5.9.5h6.7c0,.8.3,1.6.9,2.1.6.6,1.4.9,2.2.9h7.2c.8,0,1.6-.3,2.2-.9.6-.6.9-1.3.9-2.1h6.7c.4,0,.7-.2.9-.5.2-.3.2-.7,0-1-.2-.3-.5-.5-.9-.5h0ZM45.2,43.2c.2-6.6,10.1-6.6,10.3,0-.2,6.6-10.1,6.6-10.3,0ZM57.6,43.2c0-1.9-.8-3.6-2.1-5-1.4-1.3-3.2-2.1-5.1-2.1-9.6.3-9.6,13.7,0,14,1.9,0,3.8-.7,5.1-2.1,1.4-1.3,2.1-3.1,2.1-5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.1,
    y: 13.2,
    width: 62,
    height: 72
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.8,
    y: 3.2,
    width: 93,
    height: 93
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 65,
    height: 77,
    transform: "translate(19.1 8.2)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABOCAYAAACUlsCTAAAACXBIWXMAAAsSAAALEgHS3X78AAAEmUlEQVR4nO1c3dKjOgwLZ/b9X5m9ONP9wEi25LjdvahmOkAAxxH+I0DX+uKLL7744gsVx6c7PM+z7PM4jvMTutz6nBSmDHIK02RtK/7JwSNMEdIehElAtx95kLuE2AoaBExbijTQLiGWsiIJ7BiXmGxA5WBdQmTlBBLQ/uycuK8z8HSwDhkSEQUJCgGTMSK2jZBRKmiScCT71D7Vqy8TopCRKmWQkBHgWocz4DEyflFtOAlsYG47w7FyqzjIenVu2emztz0SYpviLg8VwLraFtd/Ok+sokuEMvCuRTBzZ8uq7d45IePhGoY1XNvQMiMrg2Pe0SUO0CaBxgigXFzPBq9aRxdZfGjFiYdiwCIcEiaJQK7A2jI3eZCC3ONmEWK6VEioXKTC9YqrxzArkCykco0qSzAS3MCppEvUhshouUgnRlzbGAmua2TtL9Nnx1wHy0i4bZ/neUT3yIjIrAHtq1yEyY3IiiZkQZl7yFahWER2tdAv7kNyprLHWrn7UKuIUF3jKgwNkh2zwDKuX4EsgKXKeF6msx4sQ8bIUmhsz8hRg+VaWhCM28xF1jIC5Vp+1lDQtQglLlTkIJmSe/yHGglYTMisgqXbqh90fkaeonuKnWBZnaOkTlZHoDiB9GFp1S6xkUW4A8+OV0jIZMRjHAuwxpG5hiIoS5cuqkyUbVdySzgxIgquMglShNUbSD7bVvWw0CFCxc5Vc4PgNhnvJCJix7zfjk8SYT2PMGVuy+oQUXWOJkviuZUsZWBjJKyVE+EqM/VgRiHFGbx0LCLCZbicOQ6oagNWIFWyox7WOBTXGDE9gM5tOZubVCwzhXMbrtzqopJ5OjugSVzlnBRTWUNVTC25pyAH4T9EkCdAHTNzzqnuVtX+sul9CcwiVCY7RE1YA7LALR3dqTo2Odq9VXf7duKDVZsodYRaT1Qmqc5QufML59pwiRecYDkRoVHN0A2SSvUKdSkf+RkKPGQ35EQLQbNRqD+3uELbD6gW0emYnfOuNLlV+N2IACbjMLtbgSqxoSLcLff/YLegesetdbfvreO6wVK925wkRpXb6nPipqvyzw6Brg4y2DtUkzNU2RVDBLA7yUoukz0XLEVMXn1UKbICyclMNimPOuI4jtP4FAGV1y8l2FOsSp5rTZU8CTuuga5kth+1o1/ct5K2MbhEOKaO2rPjFIK6+pVQS2zkAtXxFWI5nVnDAvs6RFF07jVeCtF3DYxzURzJrEOVH2WW6BKhKKIEyyquZBaA3C1F9lK6O3kb7xKzyVpm2tlkDkuro26AMGERjJC4L7Ypgfe1rDJIyx2umIgR10FVA4xvwqBj2JJlHNaXBZoJjG822JOr7gx1lkliG1rG9R8FhmJERBUrbjqsu8IZGYwIZZnpkKI7VYde9speAHPqEIUI1kZRfdyWKjfwlV82c+3OSCkk0MG+k4h4vjvo2M7SLdseIyEqAtH4FPodrwhVMWCLhLVEJZvfhVfyOw9ynOP/72SSiLUkMip53eeb7r6fDqc/kr9p8Jk/0Hh0K3f4if+PYPibf6/y1/9aJeLTZPxzf7aTYYqcT/wd0296+0F2YUs6VwAAAABJRU5ErkJggg=="
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.1,
    y: 8.2,
    width: 65,
    height: 77
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 33.8,
    y: 22.3,
    width: 35.3,
    height: 49
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpLarge);
export default __webpack_public_path__ + "static/media/ip-large.86f2a079ceaa830c8cb86114f768c78a.svg";
export { ForwardRef as ReactComponent };